export default __webpack_public_path__ + "static/media/HK_Lockup_RGB_Schwarz.81434ae3.svg";